
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoalibaugcab() {



    const cardData =
    {
        keyword: 'Pune to Alibaug Cab',
        heading: 'Meghana Cab : Pune to Alibaug Cab',
        headingDescription: 'Meghana Cab offers Pune to Alibaug Cab services, delivering a comfortable, scenic, and stress-free journey to the coastal getaway of Alibaug. Whether you are planning a beach day, weekend retreat, or family outing, our clean and well-maintained cabs with professional drivers ensure a smooth and enjoyable ride. Choose from various vehicle options—hatchbacks, sedans, SUVs, or tempo travellers—to suit your group size and preferences. Enjoy transparent pricing, on-time pickups, and 24/7 customer support. Book your Pune to Alibaug Cab with Meghana Cab and experience the perfect blend of convenience, comfort, and coastal charm',


        top: 'Top Places to Visit in Alibaug with Meghana Cab',

"topPlaces": [
  {
    "title": "Alibaug Beach",
    "description": "The main town beach with soft black sand, Alibaug Beach is ideal for morning walks, sunset views, and scenic moments overlooking Kolaba Fort. Comfortable and family-friendly, it also offers shore horse rides and shallow water suitable for kids."
  },
  {
    "title": "Kolaba Fort",
    "description": "Accessible on foot during low tide, this 17th-century sea fort built by Shivaji Maharaj features well-preserved bastions, temples, and water tanks. The walk across the shallow sea and interior exploration provide a rewarding blend of history and coastal scenery."
  },
  {
    "title": "Nagaon Beach",
    "description": "A popular hub for water sports, Nagaon Beach is lined with shacks and coconut groves. It offers thrilling activities such as jet skiing, parasailing, banana-boat rides, kayaking, and stand-up paddle boarding, along with a more relaxed seaside ambience."
  },
  {
    "title": "Kihim Beach",
    "description": "Known for its clean sands, lush greenery, and birdwatching opportunities, Kihim is a quieter retreat. With coconut-lined shores and seasonal migratory birds, it is perfect for peaceful strolls, nature photography, and family picnics."
  },
  {
    "title": "Mandwa Beach & Ferry",
    "description": "A gateway to Alibaug via ferry from Mumbai’s Gateway of India, Mandwa Beach is a serene coastal area with water sports, beachfront cafes, and easy access to local transport options like autos and bike rentals."
  },
  {
    "title": "Kashid Beach",
    "description": "Located around 30 km from Alibaug, Kashid offers white sands, Casuarina groves, and opportunities for surfing, beach camping, horseback riding, and dolphin-sighting boat trips in a more relaxed and scenic Vietnamese-style setting."
  },
  {
    "title": "Murud‑Janjira Fort",
    "description": "About 55 km away, this sea fort is famed for being never conquered despite multiple attacks. Boat trips take you to the island fort, where you can explore bastions, cannons, freshwater tanks, and scenic ocean views."
  },
  {
    "title": "Phansad Wildlife Sanctuary",
    "description": "Covering close to 84 km² just south of Alibaug, Phansad Sanctuary protects coastal woodlands, grasslands, and wetlands. Wildlife includes the Indian giant squirrel, leopard, sambar, and over 160 bird species. Several walking trails and waterholes offer good wildlife spotting chances."
  },
  {
    "title": "Kanakeshwar Temple & Forest",
    "description": "Located on a hill about 12 km from Alibaug, the Shiva temple requires a moderate trek through dense forest. The temple is perched atop the hill, offering panoramic views of Alibaug coast and a peaceful spiritual and nature experience."
  },
  {
    "title": "Sagaragad Fort",
    "description": "A 14th-century hill fort reached by a two-hour trek from Khandale village. Featuring a small temple, monsoon waterfalls, and a camp-friendly plateau, Sagaragad offers moderate adventure and rewarding views of the Konkan coastline."
  }
],

  "services": [
    {
      "name": "Cab from Pune to Alibaug",
      "description": "Book reliable cabs from Pune to Alibaug for comfortable and hassle-free travel with Meghana Cab."
    },
    {
      "name": "One Way Taxi Pune to Alibaug",
      "description": "Need a one-way drop to Alibaug? Our one-way taxi service from Pune offers timely pickups and flexible bookings."
    },
    {
      "name": "Round Trip Alibaug Cab Pune",
      "description": "Choose our round trip cab services from Pune to Alibaug for convenient and cost-effective travel."
    },
    {
      "name": "AC Car Hire Pune to Alibaug",
      "description": "Travel in comfort with our air-conditioned car hire service from Pune to Alibaug."
    },
    {
      "name": "SUV Cab Pune to Alibaug",
      "description": "Hire spacious SUVs for your trip from Pune to Alibaug, ideal for family and group travel."
    },
    {
      "name": "Online Booking Taxi Pune to Alibaug",
      "description": "Book your Pune to Alibaug taxi easily online with Meghana Cab — quick, safe, and convenient."
    },
    {
      "name": "Affordable Pune to Alibaug Taxi",
      "description": "Get budget-friendly taxi services from Pune to Alibaug without compromising on comfort and safety."
    },
    {
      "name": "Pune to Alibaug Beach Travel Cab",
      "description": "Plan your beach trip to Alibaug with our reliable and comfortable cab services from Pune."
    },
    {
      "name": "Weekend Trip Taxi Pune to Alibaug",
      "description": "Enjoy a relaxing weekend getaway to Alibaug with our specially designed weekend taxi packages."
    },
    {
      "name": "Pune to Alibaug Road Taxi",
      "description": "Travel safely and smoothly on the Pune to Alibaug route with Meghana Cab’s road taxi services."
    },
    {
      "name": "Alibaug Holiday Cab from Pune",
      "description": "Make your Alibaug holiday memorable with our dedicated cab services from Pune."
    },
    {
      "name": "24/7 Cab Service Pune to Alibaug",
      "description": "Our cabs are available round-the-clock for Pune to Alibaug travel, anytime you need."
    },
    {
      "name": "Budget Pune to Alibaug Sedan/SUV",
      "description": "Choose from budget-friendly sedans or SUVs for your Pune to Alibaug journey."
    },
    {
      "name": "Pune to Alibaug Driver Cabs",
      "description": "Hire experienced drivers with our Pune to Alibaug cab services for a safe and comfortable ride."
    },
    {
      "name": "Family Cab Hire Pune to Alibaug",
      "description": "Perfect family cab options from Pune to Alibaug with spacious vehicles and reliable service."
    }
  ],
  "tableData": [
    ["Cab from Pune to Alibaug", "One Way Taxi Pune to Alibaug"],
    ["Round Trip Alibaug Cab Pune", "AC Car Hire Pune to Alibaug"],
    ["SUV Cab Pune to Alibaug", "Online Booking Taxi Pune to Alibaug"],
    ["Affordable Pune to Alibaug Taxi", "Pune to Alibaug Beach Travel Cab"],
    ["Weekend Trip Taxi Pune to Alibaug", "Pune to Alibaug Road Taxi"],
    ["Alibaug Holiday Cab from Pune", "24/7 Cab Service Pune to Alibaug"],
    ["Budget Pune to Alibaug Sedan/SUV", "Pune to Alibaug Driver Cabs"],
    ["Family Cab Hire Pune to Alibaug", ""]
  ],









"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Alibaug Cab Service",
        "WhyChoosedescription": "Meghana Cab provides dependable cab service from Pune to Alibaug, perfect for weekend getaways, family vacations, or peaceful beachside retreats. Enjoy a smooth ride through scenic coastal routes with experienced drivers and well-maintained vehicles."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We offer fixed Pune to Alibaug cab fares that include fuel, tolls, and driver charges—no hidden costs. Our pricing is upfront and budget-friendly, so you can travel worry-free with complete clarity."
    },
    {
        "WhyChooseheading": "Comfortable Cabs for Coastal Travel",
        "WhyChoosedescription": "Choose from clean, air-conditioned sedans, SUVs, and tempo travellers, perfect for the 3.5 to 4.5-hour journey. All vehicles are sanitized, spacious, and designed for comfort even on curvy roads and coastal stretches."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Knowledge",
        "WhyChoosedescription": "Our professional drivers know the best routes from Pune to Alibaug, whether via Mumbai-Goa Highway or the Khopoli-Pen stretch. They ensure safe driving and optional stopovers at scenic points or eateries on the way."
    },
    {
        "WhyChooseheading": "Flexible Booking: One-Way, Round Trip & Weekend Packages",
        "WhyChoosedescription": "Planning a one-day beach trip or a weekend stay? Meghana Cab offers customizable booking options—one-way drops, round-trip returns, and multi-day packages tailored to your travel plans."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability and On-Time Pickups",
        "WhyChoosedescription": "Book a Pune to Alibaug cab at any time—early morning or late night. Our drivers arrive punctually, and our service is operational 24/7, making it perfect for both planned vacations and spontaneous trips."
    },
    {
        "WhyChooseheading": "Instant Booking with Real-Time Updates",
        "WhyChoosedescription": "Reserve your cab online, via app, or by calling us. Receive instant confirmation, live driver tracking, and timely updates for a smooth and organized travel experience from Pune to Alibaug."
    },
    {
        "WhyChooseheading": "Perfect for Families, Couples, and Groups",
        "WhyChoosedescription": "Whether you're heading to Alibaug for a family vacation, romantic beach escape, or group retreat, Meghana Cab ensures a safe, comfortable, and relaxing journey tailored to your needs."
    }
]














































    }

const faqData = [
    {
        question: "How can I book a cab from Pune to Alibaug with Meghana Cab?",
        answer: "You can book a Pune to Alibaug cab easily by calling Meghana Cab at +91 9075462128 or through our website."
    },
    {
        question: "What types of vehicles are available for Pune to Alibaug trips?",
        answer: "We offer a variety of vehicles including sedans, SUVs, and tempo travellers depending on your travel needs."
    },
    {
        question: "Are Meghana Cab drivers familiar with the Pune to Alibaug route?",
        answer: "Yes, our experienced drivers are well-acquainted with the Pune to Alibaug route and ensure a safe journey."
    },
    {
        question: "Can I book a one-way or round-trip cab from Pune to Alibaug?",
        answer: "Yes, both one-way and round-trip services are available with Meghana Cab."
    },
    {
        question: "What is included in the Pune to Alibaug cab fare?",
        answer: "The fare includes driver charges, fuel, and tolls. Parking or additional charges may apply depending on your specific requirements."
    },
    {
        question: "Are Meghana Cab vehicles sanitized for safety?",
        answer: "Yes, all our vehicles are thoroughly sanitized before and after every trip to ensure passenger safety."
    },
    {
        question: "Is the cab service available 24/7 from Pune to Alibaug?",
        answer: "Yes, Meghana Cab operates 24/7 to meet your travel schedule to and from Alibaug."
    },
    {
        question: "Can I request special amenities like a child seat or extra luggage space?",
        answer: "Yes, we can arrange special requirements upon prior request during booking."
    },
    {
        question: "What payment options are accepted for Pune to Alibaug cab bookings?",
        answer: "We accept UPI, debit/credit cards, net banking, and cash."
    },
    {
        question: "How can I contact Meghana Cab for Pune to Alibaug bookings?",
        answer: "You can reach Meghana Cab at +91 9075462128 for bookings and inquiries."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Nilesh Patankar',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Our Pune to Alibaug ride with Meghana Cab was smooth and the driver was very polite. Great experience overall!”',
    },
    {
        name: 'Ms. Rutuja Sawant',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Very professional service by Meghana Cab on our Pune to Alibaug trip. The vehicle was clean and comfortable.”',
    },
];









































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const alibaugCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Alibaug Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-alibaug-cab.jpg",
  "description": "Book reliable and affordable Pune to Alibaug taxi services with Meghana Cabs. One way, round trip, AC cars, SUVs, and family travel options available for Alibaug beach trips and holidays.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": [
    "One Way Taxi Pune to Alibaug",
    "Round Trip Cab Pune to Alibaug",
    "AC Car Hire Pune to Alibaug",
    "SUV Rental Pune to Alibaug",
    "Family Cab Hire Pune to Alibaug"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Pune to Alibaug Taxi Offers",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "One Way Taxi Pune to Alibaug"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Round Trip Cab Pune to Alibaug"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "SUV Rental Pune to Alibaug"
        }
      }
    ]
  }
};






    return (
        <div>


<Helmet>
  <title>Pune to Alibaug Cab | Meghana Cabs</title>
  <meta
    name="description"
    content="Book reliable and affordable Pune to Alibaug taxi services with Meghana Cabs. One way, round trip, AC cars, SUVs, and family travel options available for Alibaug beach trips and holidays."
  />
  <meta
    name="keywords"
    content="Cab from Pune to Alibaug, One Way Taxi Pune to Alibaug, Round Trip Alibaug Cab Pune, AC Car Hire Pune to Alibaug, SUV Cab Pune to Alibaug, Online Booking Taxi Pune to Alibaug, Affordable Pune to Alibaug Taxi, Pune to Alibaug Beach Travel Cab, Weekend Trip Taxi Pune to Alibaug, Pune to Alibaug Road Taxi, Alibaug Holiday Cab from Pune, 24/7 Cab Service Pune to Alibaug, Budget Pune to Alibaug Sedan/SUV, Pune to Alibaug Driver Cabs, Family Cab Hire Pune to Alibaug"
  />
  <script type="application/ld+json">
    {JSON.stringify(alibaugCabSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/42.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoalibaugcab;